var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(-41 -260)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(41 260)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(51 269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M14.374,20a5.572,5.572,0,0,1-1.912-.342,20.385,20.385,0,0,1-7.4-4.718,20.384,20.384,0,0,1-4.718-7.4A5.532,5.532,0,0,1,.06,4.819,5.673,5.673,0,0,1,2.975.666,5.569,5.569,0,0,1,5.642,0a.625.625,0,0,1,.611.494l.981,4.578a.625.625,0,0,1-.169.573L5.388,7.321a16.451,16.451,0,0,0,7.291,7.291l1.676-1.676a.625.625,0,0,1,.573-.169l4.578.981a.625.625,0,0,1,.494.611,5.569,5.569,0,0,1-.666,2.667,5.673,5.673,0,0,1-4.153,2.916,5.559,5.559,0,0,1-.807.059ZM5.142,1.277A4.379,4.379,0,0,0,1.517,7.111,18.956,18.956,0,0,0,12.889,18.484a4.379,4.379,0,0,0,5.834-3.626L15,14.06l-1.751,1.751a.625.625,0,0,1-.708.124A17.7,17.7,0,0,1,4.066,7.46a.625.625,0,0,1,.124-.708L5.94,5Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIcon);
export default __webpack_public_path__ + "static/media/contact-phone-icon.cce5a5c421d1424fe3c6aebd71127cd9.svg";
export { ForwardRef as ReactComponent };